import { format } from 'date-fns';
import { ThresholdsDTO } from '../dto/ThresHoldDTO';
import { ThresholdData } from '../../domain/ThresholdData';

export class ThresholdMapper {
  static toDomain(dto: ThresholdsDTO): ThresholdData {
    return new ThresholdData(
      dto.workshop_id,
      dto.threshold_capacity,
      dto.modified_at === null
        ? '-'
        : format(new Date(dto.modified_at), 'yyy-MM-dd:HH:mm:ss'),
      dto.modified_by
    );
  }

  static toDomainList(dtos: ThresholdsDTO[]): ThresholdData[] {
    return dtos.map(this.toDomain);
  }
}
